import { IconButton } from '@material-ui/core';
import type { Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import ClearIcon from '@material-ui/icons/Clear';
import React from 'react';

import { Button, Colors } from '../../legacy/button/Button.component';
import styles from './WonAuctionModal.module.css';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    exitButton: {
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    exitIcon: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      color: 'white',
    },
  }),
);

interface Props {
  title: string;
  seller: string;
  description: string;
  image: string;
  hideModal: () => void;
  handleGotIt?: () => void;
}

interface WonAuctionModalProps {
  hideModal: () => void;
}

const WonAuction: React.FC<Props> = ({
  hideModal,
  title,
  seller,
  description,
  image,
  handleGotIt,
}: Props) => {
  const classes = useStyles();

  const gotIt = () => {
    if (handleGotIt) {
      handleGotIt();
    }
    hideModal();
  };

  return (
    <div className={styles.winningCard}>
      <div className={styles.imageContainer}>
        <video className={styles.image} src={image} autoPlay loop muted />
      </div>
      <div className={styles.cardDetails}>
        <div className={styles.headerContainer}>
          <div className={styles.titleContainer}>
            <div className={styles.winningTitle}>
              Congrats! You won the auction.
            </div>
            <div className={styles.winningSubTitle}>
              You are now the sole owner of this artwork.
            </div>
          </div>
          <div className={styles.exitButtonContainer}>
            <IconButton className={classes.exitButton} onClick={hideModal}>
              <ClearIcon className={classes.exitIcon} />
            </IconButton>
          </div>
        </div>

        <div className={styles.headerContainer}>
          <div className={styles.sellerInfoContainer}>
            <div className={styles.profileName}>by {seller}</div>
            <div className={styles.title}>{title}</div>
            <div className={styles.description}>{description}</div>
          </div>
        </div>
        <Button
          color={Colors.COLOR_SCHEME_2}
          className={styles.gotItButton}
          onClick={gotIt}
        >
          Got It
        </Button>
      </div>
    </div>
  );
};

export const WonAuctionModal =
  (
    title: string,
    seller: string,
    description: string,
    image: string,
    handleGotIt?: () => void,
  ) =>
  ({ hideModal }: WonAuctionModalProps) => {
    return (
      <WonAuction
        title={title}
        seller={seller}
        image={image}
        description={description}
        hideModal={hideModal}
        handleGotIt={handleGotIt}
      />
    );
  };
